/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "Бэҕэһээ",
        "-2": "Иллэрээ күн",
        "0": "Бүгүн",
        "1": "Сарсын",
        "2": "Өйүүн",
        "future": {
          "other": "{0} күнүнэн"
        },
        "past": {
          "other": "{0} күн ынараа өттүгэр"
        }
      },
      "day-narrow": {
        "-1": "Бэҕэһээ",
        "-2": "Иллэрээ күн",
        "0": "Бүгүн",
        "1": "Сарсын",
        "2": "Өйүүн",
        "future": {
          "other": "{0} күнүнэн"
        },
        "past": {
          "other": "{0} күн ынараа өттүгэр"
        }
      },
      "day-short": {
        "-1": "Бэҕэһээ",
        "-2": "Иллэрээ күн",
        "0": "Бүгүн",
        "1": "Сарсын",
        "2": "Өйүүн",
        "future": {
          "other": "{0} күнүнэн"
        },
        "past": {
          "other": "{0} күн ынараа өттүгэр"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "{0} чааһынан"
        },
        "past": {
          "other": "{0} чаас ынараа өттүгэр"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "{0} чааһынан"
        },
        "past": {
          "other": "{0} чаас ынараа өттүгэр"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "{0} чааһынан"
        },
        "past": {
          "other": "{0} чаас ынараа өттүгэр"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "{0} мүнүүтэннэн"
        },
        "past": {
          "other": "{0} мүнүүтэ ынараа өттүгэр"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "{0} мүнүүтэннэн"
        },
        "past": {
          "other": "{0} мүнүүтэ ынараа өттүгэр"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "{0} мүнүүтэннэн"
        },
        "past": {
          "other": "{0} мүнүүтэ ынараа өттүгэр"
        }
      },
      "month": {
        "-1": "ааспыт ый",
        "0": "бу ый",
        "1": "аныгыскы ый",
        "future": {
          "other": "{0} ыйынан"
        },
        "past": {
          "other": "{0} ый ынараа өттүгэр"
        }
      },
      "month-narrow": {
        "-1": "ааспыт ый",
        "0": "бу ый",
        "1": "аныгыскы ый",
        "future": {
          "other": "{0} ыйынан"
        },
        "past": {
          "other": "{0} ый ынараа өттүгэр"
        }
      },
      "month-short": {
        "-1": "ааспыт ый",
        "0": "бу ый",
        "1": "аныгыскы ый",
        "future": {
          "other": "{0} ыйынан"
        },
        "past": {
          "other": "{0} ый ынараа өттүгэр"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ааспыт кыбаартал",
        "0": "бу кыбаартал",
        "1": "кэлэр кыбаартал",
        "future": {
          "other": "{0} кыбаарталынан"
        },
        "past": {
          "other": "{0} кыбаартал анараа өттүгэр"
        }
      },
      "quarter-narrow": {
        "-1": "ааспыт кыбаартал",
        "0": "бу кыбаартал",
        "1": "кэлэр кыбаартал",
        "future": {
          "other": "{0} кыбаарталынан"
        },
        "past": {
          "other": "{0} кыб. анараа өттүгэр"
        }
      },
      "quarter-short": {
        "-1": "ааспыт кыбаартал",
        "0": "бу кыбаартал",
        "1": "кэлэр кыбаартал",
        "future": {
          "other": "{0} кыбаарталынан"
        },
        "past": {
          "other": "{0} кыб. анараа өттүгэр"
        }
      },
      "second": {
        "0": "билигин",
        "future": {
          "other": "{0} сөкүүндэннэн"
        },
        "past": {
          "other": "{0} сөкүүндэ ынараа өттүгэр"
        }
      },
      "second-narrow": {
        "0": "билигин",
        "future": {
          "other": "{0} сөкүүндэннэн"
        },
        "past": {
          "other": "{0} сөк. анараа өттүгэр"
        }
      },
      "second-short": {
        "0": "билигин",
        "future": {
          "other": "{0} сөкүүндэннэн"
        },
        "past": {
          "other": "{0} сөк. анараа өттүгэр"
        }
      },
      "week": {
        "-1": "ааспыт нэдиэлэ",
        "0": "бу нэдиэлэ",
        "1": "кэлэр нэдиэлэ",
        "future": {
          "other": "{0} нэдиэлэннэн"
        },
        "past": {
          "other": "{0} нэдиэлэ анараа өттүгэр"
        }
      },
      "week-narrow": {
        "-1": "ааспыт нэдиэлэ",
        "0": "бу нэдиэлэ",
        "1": "кэлэр нэдиэлэ",
        "future": {
          "other": "{0} нэдиэлэннэн"
        },
        "past": {
          "other": "{0} нэдиэлэ анараа өттүгэр"
        }
      },
      "week-short": {
        "-1": "ааспыт нэдиэлэ",
        "0": "бу нэдиэлэ",
        "1": "кэлэр нэдиэлэ",
        "future": {
          "other": "{0} нэдиэлэннэн"
        },
        "past": {
          "other": "{0} нэдиэлэ анараа өттүгэр"
        }
      },
      "year": {
        "-1": "Былырыын",
        "0": "быйыл",
        "1": "эһиил",
        "future": {
          "other": "{0} сылынан"
        },
        "past": {
          "other": "{0} сыл ынараа өттүгэр"
        }
      },
      "year-narrow": {
        "-1": "Былырыын",
        "0": "быйыл",
        "1": "эһиил",
        "future": {
          "other": "{0} сылынан"
        },
        "past": {
          "other": "{0} сыл ынараа өттүгэр"
        }
      },
      "year-short": {
        "-1": "Былырыын",
        "0": "быйыл",
        "1": "эһиил",
        "future": {
          "other": "{0} сылынан"
        },
        "past": {
          "other": "{0} сыл ынараа өттүгэр"
        }
      }
    },
    "locale": "sah"
  });
}